export default {"src":"/_next/static/media/lieutenant.5161f67c.svg","height":628,"width":628,"blurWidth":0,"blurHeight":0};